<template>
  <div class="costumm-select-wrap stopProp">
    <div class="custom-select" :class="{ open: open }" :tabindex="tabindex">
      <div
        class="selected"
        ref="open"
        :class="{ open: open }"
        @click="open = !open"
        :data-attr="_.get(selected, 'id')"
      >
        {{ _.get(selected, "title") }}
      </div>

      <div class="items" :class="{ selectHide: !open }">
        <div
          class="item"
          :class="_.get(option, 'id') === _.get(selected, 'id') ? 'active' : ''"
          v-for="(option, i) in optionsPrepared"
          :key="i"
          :data-attr="option.id"
          @click="
            activeIndex = option.id;
            open = false;
          "
        >
          {{ option.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options", "tabindex", "value", "disableall", "isYear", "isBranch", "placeholderText"],
  data() {
    return {
      open: false,
      activeIndex: this.value
    };
  },

  mounted() {
    let stop = document.querySelectorAll(
      ".costumm-select-wrap.stopProp .items"
    );
    stop.forEach(function(item) {
      // item.onclick = function(e){
      //    e.stopPropagation();
      // }
      item.addEventListener("scroll", function(e) {
        e.stopPropagation();
      });
      item.addEventListener("mousewheel", function(e) {
        e.stopPropagation();
      });
    });

    window.addEventListener("click", e => {
      if (document.querySelectorAll(".costumm-select-wrap")) {
        // Clicked in box
      } else {
        this.open = false;
      }
    });

    //
    //
    // if (
    //   this.$route.params.path2 !== undefined &&
    //   (this.$route.params.path2 === "press-releases" ||
    //     this.$route.params.path2 === "news")
    // ) {
    //   return;
    // }

    // this.$emit("input", this.select);
  },

  watch: {
    selected: function() {
      if (this.selected) {
        this.$emit("input", this.selected.id);
      }
    },
    open(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.addCloseHandler);
      } else {
        document.removeEventListener("click", this.addCloseHandler);
      }
    }
  },
  methods: {
    addCloseHandler(e) {
      if (!this.$refs.open.contains(e.target)) {
        this.open = false;
      }
    }
  },
  computed: {
    optionsPrepared: function() {
      let ret = JSON.parse(JSON.stringify(this.options));
      if (this.disableall != 1)
        this.isYear ? ret.unshift({ title: this.$fn.tr("Pick Up Year"), id: 0 }) : this.placeholderText ? ret.unshift({ title: this.placeholderText, id: 0 }) : (this.isBranch ? ret.unshift({ title: this.$fn.tr("choose branch"), id: 0 }) : ret.unshift({ title: this.$fn.tr("all"), id: 0 }));
      if (!_.get(ret, 0)) ret = [];
      return ret;
    },
    selected: function() {
      let ret = _.find(this.options, { id: this.activeIndex });
      if (ret) return ret;

      return this.optionsPrepared[0];
    }
  }
};
</script>

<style>
.costumm-select-wrap {
  position: relative;
  width: 100%;
  height: 46px;
  z-index: 10;
}

.custom-select {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: left;
  outline: none;

  line-height: 46px;
  border-radius: 6px;
  border: 1px solid #bcbec0;
  transition: 0.6s;
  overflow: hidden;
  background-color: #fff;
}

.custom-select:after {
  position: absolute;
  display: block;
  content: "";
  top: 46px;
  right: 20px;
  width: 5px;
  height: 100%;
  z-index: 999;
  background-color: #fff;
  transition: 0s;
  transition-delay: 0s;
  opacity: 1;
}

.custom-select.open:after {
  opacity: 0;
  transition: 0.1s;
  transition-delay: 0.6s;
}

.custom-select .selected {
  position: relative;
  background-color: #fff;
  color: #444958;
  padding-left: 15px;
  padding-right: 45px;
  cursor: pointer;
  user-select: none;

  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  font-size: 12px;
  line-height: 46px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  transition: 0s;
  transition-delay: 0.6s;
  backface-visibility: hidden;
}

.selected.open {
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 17px;
  right: 20px;
  border: solid #444958;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transition: 0.6s;
}
.custom-select .selected.open:after {
  transform: rotate(225deg);
  -webkit-transform: rotate(225deg);
}

.custom-select .items {
  position: relative;
  background-color: #fff;
  max-height: 120px;
  width: calc(100% - 20px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  z-index: 99;
  backface-visibility: hidden;
  transition: 0.6s;
}

.custom-select .items::-webkit-scrollbar {
  width: 3px;
}

.custom-select .items::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #bcbec0;
  border-radius: 10px;
}

.custom-select .items::-webkit-scrollbar-thumb {
  background: #0061af;
  border-radius: 10px;
}

.selected.open ~ .items::-webkit-scrollbar {
}

.custom-select .item {
  color: #444958;
  padding: 0 15px 0 15px;
  cursor: pointer;
  user-select: none;
  height: auto;

  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 20px;
  font-size: 12px;
  transition: 0.6s;
}

.withFirst .custom-select .item:first-child {
  display: block;
}
.custom-select .item:first-child {
  display: none;
}

.custom-select .item:hover {
  color: #0061af;
  text-decoration: underline;
}

.custom-select .selectHide {
  max-height: 0px;
  backface-visibility: hidden;
  margin-bottom: 0;
}
</style>
